"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "StoredMoney", {
    enumerable: true,
    get: function() {
        return StoredMoney;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const StoredMoney = _zod.z.instanceof(_bson.Decimal128);
